(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/event-list/assets/javascripts/event-list-item.js') >= 0) return;  svs.modules.push('/components/marketplace/event-list/assets/javascripts/event-list-item.js');
"use strict";


const formatDate = svs.components.lbUtils.helpers.formatDate.formatDate;
const getBetRowAriaLabel = svs.components.marketplace.betProposal.helpers.getLabels.getBetRowAriaLabel;
const EventListItem = _ref => {
  let event = _ref.event,
    productId = _ref.productId;
  const eventComment = event.eventComment,
    eventDescription = event.eventDescription,
    eventNumber = event.eventNumber,
    matchStart = event.matchStart;
  return React.createElement("li", {
    "aria-label": getBetRowAriaLabel({
      productId,
      eventNumber,
      eventDescription,
      eventComment,
      matchStart
    }),
    className: "event-list-item",
    role: "group",
    tabIndex: "0"
  }, React.createElement("div", {
    "aria-hidden": "true",
    className: "event-list-row"
  }, React.createElement("div", {
    className: "event-number"
  }, eventNumber), React.createElement("div", {
    className: "event-description notranslate"
  }, React.createElement("p", null, eventDescription), React.createElement("p", {
    className: "event-description-extra"
  }, eventComment)), React.createElement("div", {
    className: "fc-grey-600 event-date"
  }, React.createElement("p", null, formatDate(new Date(matchStart), true, true, true)))));
};
setGlobal('svs.components.marketplace.eventList.EventListItem', EventListItem);

 })(window);